<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Power of Attorney</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/powerofattorney/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/powerofattorney/edit?goveva=true&email=', 'method':'put', 'menu': 'powerofattorney'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <!-- <form (document:click)="cesDate.close();"> -->
            <div class="row">
              <div class="col-md-3">
                <label>Name of the Person (Power of Attorney)
                </label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameOfPerson">
                </div>
                <br>
              </div>
              <!-- <div class="col-lg-4 col-md-4 col-sm-4">
                <label>Date of meeting in which POA approved
                </label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="toDatecal" class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                    name="dpCessation" ngbDatepicker #cesDate="ngbDatepicker" [(ngModel)]="dateOfMeeting"
                    (click)="cesDate.toggle();">
                  <button class="input-group-addon" (click)="cesDate.toggle();" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
  
  
              <div class="col-md-3">
                <!-- <label>Date of withdrawal of Power of Attorney </label> -->
                <!-- <label>From</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfPOA" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfPOA" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfPOA">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
              <div class="col-md-3">
                <!-- <label>Date of Board Meeting in which Power of Attorney Approved </label> -->
                <!-- <label>To</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateOfMeeting" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfMeeting" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfMeeting">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
  
  
  
  
              <div class="col-lg-2 col-md-2 col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfPoa" [dtTrigger]="dtTriggerPoa"
                class="table table-hover compact cell-border stripe" id="powerofattorneylistTable">
                <thead>
                  <tr>
                    <th style="width: 25%">Name and Designation of the person in <br>whose favour Power of Attorney is issued
                    </th>
                    <th style="width: 25%">Date of Board meeting in <br>which Power of Attorney Approved </th>
                    <th style="display: none">Date of Board meeting in which Power of Attorney Approved </th>
                    <th style="width: 20%">Date of withdrawal of <br>Power of Attorney</th>
                    <th style="display: none">Date of withdrawal of Power of Attorney</th>
                    <th style="width: 10%">Action
                    <!-- <span [appHasPermission]="{'Url': '/register/powerofattorney/edit?goveva=true&email=', 'method':'put', 'menu': 'powerofattorney'}" class="btn btn-sm btn-primary mb-2" type="button">Action</span></th> -->
                  </tr>
                </thead>
                <tbody>
  
                  <tr *ngFor="let poa of poaList">
                    <td style="width: 25%">{{poa.namedesgnPower}}</td>
                    <td style="width: 25%">
                      <span style="display: none">{{poa.dobminPower | date : "yMMdd"}}</span>
                      {{poa.dobminPower | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{poa.dobminPower | date : "dd-MM-y"}}
                    </td>
                    <td style="width: 20%">
                      <span style="display: none">{{poa.datewithdrawalPower | date : "yMMdd"}}</span>
                      {{poa.datewithdrawalPower | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{poa.datewithdrawalPower | date : "dd-MM-y"}}
                    </td>
                    <td style="width: 10%">
                      <button type="button" class="btn-sm btn btn-warning" data-toggle="modal" [appHasPermission]="{'Url': '/register/powerofattorney/edit?goveva=true&email=', 'method':'put', 'menu': 'powerofattorney'}" type="button"
                        (click)="getPoaOnEdit(poa._id)">
                        <span class="fa fa-pencil"> </span>
                      </button>
  
                      <button type="button" class="btn-sm btn btn-danger" [appHasPermission]="{'Url': '/register/powerofattorney/edit?goveva=true&email=', 'method':'put', 'menu': 'powerofattorney'}" type="button" (click)="confirmDelete(poa._id)">
                        <span class="icmn-bin"></span>
                      </button>
  
                      <button type="button" class="btn-sm btn btn-primary" *ngIf="poa.DocumentManagementID!=null"
                        (click)="downloadFile(poa.DocumentManagementID)">
                        <span class="fa fa-download"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
  
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete power of attorney details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletePoa()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>